import { FC, useState, useMemo } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { Paper } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import { getRowsPerPageOptions } from 'utils/pagination';
import { toFormatDateTime } from 'utils';
export const DepartmentLogs: FC = () => {
  const {
    importTableStore: { getDepartmentLogs, departmentView },
    notificationStore: { openNotification },
  } = useStore();
  const classes = useStyles();
  const getDepartmentReq = useQuery('getDepartment', () => getDepartmentLogs(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  useAppPreloader(getDepartmentReq.isFetching);
  const rows = useMemo(() => {
    return !getDepartmentReq.isFetching ? departmentView : [];
  }, [departmentView, getDepartmentReq.isFetching]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'created_at',
      headerName: 'ACCOUNT CREATED',
      flex: 0.7,
      valueGetter: (params) => toFormatDateTime(params.row.created_at),
    },
    { field: 'ou', headerName: 'FULL NAME', flex: 1 },
    {
      field: 'status',
      headerName: 'ACCOUNT STATUS',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = params.value as string;

        return (
          <div style={{ color: params.row.status === 0 ? 'red' : 'green' }}>
            {value === 'both' ? 'created and linked' : value}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
    </>
  );
};
